import classnames from 'classnames'
import CollectionCard from 'components/shared/CollectionCard/CollectionCard'
import PropTypes from 'prop-types'
import React from 'react'
import { withCookies } from 'react-cookie'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'

import './CollectionList.scss'

const CollectionList = ({
  i18n,
  t,
  collections,
  gtm = {},
  homepageVariant = false,
}) => {
  const { entities = {} } = collections

  return (
    <div
      className={classnames(
        'c-collection-list',
        homepageVariant
          ? 'c-collection-list--homepage'
          : 'c-collection-list--paths'
      )}
      id={homepageVariant ? null : 'skiptocontent'}
    >
      {homepageVariant ? null : (
        <h2 className={'c-collection-list__title'}>
          {t('meta.collection.list-title')}
        </h2>
      )}
      <div className="c-collection-list__cards">
        {Object.entries(entities).map(([id, collection]) => (
          <CollectionCard
            key={`collection-${id}`}
            locale={i18n.language}
            collection={collection}
            gtm={gtm}
            t={t}
          />
        ))}
      </div>
    </div>
  )
}

CollectionList.propTypes = {
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
  collections: PropTypes.object.isRequired,
  homepageVariant: PropTypes.bool,
  gtm: PropTypes.object,
}

const mapStateToProps = ({ collections = {} }) => {
  return { collections }
}

export { CollectionList }
export default withNamespaces('translations')(
  connect(mapStateToProps)(withCookies(CollectionList))
)
